import { NgModule } from '@angular/core';

import { FeatherIconDirective } from '@core/directives/core-feather-icons/core-feather-icons';

@NgModule({
	declarations: [FeatherIconDirective],
	exports: [FeatherIconDirective],
})
export class CoreDirectivesModule {}
